import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';

const useIsAdmin = (): boolean => {
  const { currentUser } = useSelector(selectUser);
  return currentUser.role === 'admin';
};

export default useIsAdmin;
